import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
const primaryTabRoutes = new Set(['/', '/categories', '/offers', '/rx', '/now', '/account']);
function getScrollKey(pathname: string) {
  return `dawaak-scroll:${pathname}`;
}
export function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  const previousPathname = useRef(pathname);
  useEffect(() => {
    const previousPath = previousPathname.current;
    if (primaryTabRoutes.has(previousPath)) {
      sessionStorage.setItem(getScrollKey(previousPath), String(window.scrollY));
    }
    const restorePosition = primaryTabRoutes.has(pathname) ? Number(sessionStorage.getItem(getScrollKey(pathname)) ?? 0) : 0;
    const frame = window.requestAnimationFrame(() => {
      window.scrollTo({
        top: Number.isFinite(restorePosition) ? restorePosition : 0,
        left: 0,
        behavior: 'instant'
      });
    });
    previousPathname.current = pathname;
    return () => window.cancelAnimationFrame(frame);
  }, [pathname]);
  return null;
}